function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 45,
  fill: "#3FC150",
  rx: 6.667
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M32.539 12.45a14.057 14.057 0 00-9.98-4.117c-7.776 0-14.104 6.298-14.107 14.04a13.953 13.953 0 001.883 7.018l-2.002 7.276 7.479-1.953a14.155 14.155 0 006.742 1.71h.005c7.776 0 14.105-6.3 14.108-14.04a13.924 13.924 0 00-4.128-9.933zm-9.98 21.602h-.005c-2.104 0-4.167-.563-5.968-1.627l-.428-.253-4.437 1.16 1.184-4.307-.279-.442a11.596 11.596 0 01-1.792-6.21c.002-6.434 5.262-11.668 11.73-11.668a11.67 11.67 0 018.29 3.422 11.57 11.57 0 013.43 8.256c-.002 6.434-5.262 11.67-11.725 11.67zm6.432-8.74c-.352-.175-2.086-1.024-2.409-1.141-.323-.117-.558-.175-.793.176-.235.35-.91 1.14-1.116 1.375-.206.234-.411.263-.764.088-.352-.176-1.488-.546-2.834-1.741-1.048-.93-1.756-2.08-1.961-2.43-.206-.352-.002-.524.154-.716.382-.472.764-.966.881-1.2.118-.235.06-.44-.03-.615-.087-.176-.792-1.902-1.086-2.605-.286-.684-.576-.591-.793-.602-.205-.01-.44-.012-.675-.012-.235 0-.617.087-.94.439-.324.35-1.234 1.2-1.234 2.926 0 1.727 1.263 3.395 1.44 3.63.175.233 2.485 3.777 6.02 5.296.842.362 1.498.578 2.01.74.845.266 1.613.229 2.22.138.678-.1 2.086-.848 2.38-1.668.294-.82.294-1.522.205-1.668-.088-.146-.323-.234-.675-.41z"
}));

function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45"
  }, props), _ref);
}

export default SvgWhatsapp;